/*
 * Currently we parse things like:
 *   - 8'
 *   - 8' 8"
 *   - 8' 8 1/8"
 *   - 8 1/8"
 *   - 8 m
 *   - 8 meters
 *   - 8 feet
 *   - 8 ft
 *   - 8 inches
 *   - 8 in
 *   - 8 ft 8 in
 *   - 8 ft 8 inches
 *   - 8 feet 8 in
 *   - 8 feet 8 inches
 *  var whiteSpace = /(\s{0,1})/;
 *  var posNegInteger = /-{0,1}\d/;
 *  var posNegDecimal = /-{0,1}\d*\.{0,1}\d/;
 */

// TODO = remove this vvvv
var ENGLISH_UNITS = "english";
var gUnits = ENGLISH_UNITS;

var forcePrecisionDecimalPlaces = 2;
var momentPrecisionDecimalPlaces = 2;

// matches 4.4 " or 4.4 inches or 4.4 in
var inchesRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\"|in|inch|inches)(\s{0,})$/);
var inchesSplit = new RegExp(/(\"|in|inch|inches)/);
// matches 1/4 " or 1/4 inches or 1/4 in
var inchFracRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/);
// matches 4.4 ' or 4.4 feet or 4 ft
var feetRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\'|ft|feet)(\s{0,})$/);
var feetSplit = new RegExp(/(\'|ft|feet)/);
// matches 4' 4" or 4ft 4in or 4feet 4inches
var feetInchesRegEx = new RegExp(/^(\s{0,})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*((\s{0,})|(\s{0,1})(\"|in|inch|inches)(\s{0,}))$/);
// matches 4' 4 1/4" or 4ft 4 1/4in or 4feet 4 1/4inches
var feetInchesInchFracRegEx = new RegExp(/^(\s{0,})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*(\s{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/);
// matches -42 or 42
var integerRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})$/);
// matches -42.0 or 42
var decimalRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})$/);
// matches 42 m or 42 meters
var meterRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(m|meter|meters)(\s{0,})$/);
var metersSplit = new RegExp(/(m|meter|meters)/);
// matches 42 cm or 42 centimeters
var centimeterRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})((cm)|(centimeter)|(centimeters))(\s{0,})$/);
var centimetersSplit = new RegExp(/(cm|centimeter|centimeters)/);
// matches 42 mm or 42 millimeters
var millimeterRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(mm|millimeter|millimeters)(\s{0,})$/);
var millimetersSplit = new RegExp(/(mm|millimeter|millimeters)/);

function parseInch(s) {
  var tokens = s.split(inchesSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Inches: " + s);
    return 0;
  }
  return Number(tokens[0]);
}

function parseInchFraction(s) {
  var tokens = s.split(inchesSplit);
  if (tokens.length > 0) {
    tokens = tokens[0].split(/\//);
    if (tokens.length > 1) {
      var numerator = tokens[0];
      var denomenator = parseInch(tokens[1]);
      if (!isNaN(numerator) && !isNaN(denomenator)) {
        return Number(numerator) / Number(denomenator);
      }
    }
  }
  throw ("Error Parsing Inch Fraction: " + s);
  return 0;
}

function parseFeet(s) {
  var tokens = s.split(feetSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Feet: " + s);
    return 0;
  }
  return Number(tokens[0] * 12);
}

function parseCentimeters(s) {
  var tokens = s.split(centimetersSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Centimeters: " + s);
    return 0;
  }
  return Number(tokens[0]) * 0.39370078;
}

function parseMillimeters(s) {
  var tokens = s.split(millimetersSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Millimeters: " + s);
    return 0;
  }
  return Number(tokens[0]) * 0.039370078;
}

function parseMeters(s) {
  var tokens = s.split(metersSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Meters: " + s);
    return 0;
  }
  return Number(tokens[0]) * 39.370078;
}


export function wsParseLength(s, blank_unit) {

  // replace smart quotes
  s = s.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');

  if (s.match(integerRegEx) || s.match(decimalRegEx)) {
    if (blank_unit && (blank_unit === "inches" || blank_unit === "in")) {
      return Number(s);
    } else {
      return Number(s) * 12;
    }
  }
  if (s.match(inchesRegEx)) { return parseInch(s); }

  if (s.match(inchFracRegEx)) { return parseInchFraction(s); }

  if (s.match(feetRegEx)) { return parseFeet(s); }

  if (s.match(feetInchesRegEx)) {
    var tokens = s.split(feetSplit);
    try {
      var feet = Number(tokens[0]);
      var inches = parseInch(tokens[2]); //why is this not 1?
      return feet * 12 + inches;
    } catch (error) {
      console.log(error);
      return 0;
    }
  }

  if (s.match(feetInchesInchFracRegEx)) {
    var tokens = s.split(feetSplit);
    var feet = Number(tokens[0]);
    var tokens = tokens[2].split(" ");
    var inches = Number(tokens[1]);
    var inchFrac = parseInchFraction(tokens[2]);
    return feet * 12 + inches + inchFrac;
  }

  if (s.match(meterRegEx)) {
    var tokens = s.split(metersSplit);
    var meters = Number(tokens[0]);
    return meters * 39.370078;
  }

  if (s.match(centimeterRegEx)) {
    var tokens = s.split(centimetersSplit);
    var cm = Number(tokens[0]);
    return cm * 0.39370078;
  }

  if (s.match(millimeterRegEx)) {
    var tokens = s.split(millimetersSplit);
    var mm = Number(tokens[0]);
    return mm * 0.039370078;
  }

  return NaN;
}

function showInches(num) {
  return Number(num).toFixed(2) + " in";
}

export function showFeetInches(lengthInches, withInchesCodes = false) {
  var feet = Math.floor(lengthInches / 12);
  var inches = lengthInches - feet * 12;
  //var inchFraction = inches % 1;
  //inches = Math.floor(inches)
  //if(inchFraction !== 0.0) {
  //    inches += " " + math.format(math.fraction(inchFraction), { fraction: 'ratio' });
  //}
  return withInchesCodes ? feet + "&#39; " + inches + '&#34; ' : feet + "' " + inches + '" ';
}

function showLengthMeters(inches) {
  return Number(inches / 39.370078).toFixed(2) + " m";
}

function showLengthMillimeters(inches) {
  return Number(inches / 39.370078 * 1000).toFixed(2) + " mm";
}

function showLengthWithUnits(inches, withInchesCodes = false) {
  if (gUnits === ENGLISH_UNITS) {
    return showFeetInches(inches, withInchesCodes);
  } else {
    return showLengthMeters(inches);
  }
}

/* inches or mm */

function smallLengthUnit() {
  if (gUnits === ENGLISH_UNITS) {
    return "in";
  } else {
    return "mm";
  }
}

function showSmallLength(inches) {
  return (gUnits === ENGLISH_UNITS) ? inches : inches * 25.4;
}

function showDistanceLength(inches) {
  return (gUnits === ENGLISH_UNITS) ? inches : inches * 0.0254;
}

function showSmallLengthWithUnits(inches) {
  if (gUnits === ENGLISH_UNITS) {
    return showInches(inches);
  } else {
    return showLengthMillimeters(inches);
  }
}

/*
 * Forces
 */
var lbsRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,})$/);
var lbsSplit = new RegExp(/(lb|lbs|pound|pounds)/);
// matches 42 k, 42.0 k or 42 kips or 42.0 kips
var kipsRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(\s{0,})$/);
var kipsSplit = new RegExp(/(k|kip|kips)/);
// matches 42 tons, 42.0 ton
var tonsRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(ton|tons)(\s{0,})$/);
var tonsSplit = new RegExp(/(ton|tons)/);
// matches 42 n, 42.0 newton or 42 newtons
var newtonsRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(n|newton|newtons)(\s{0,})$/);
var newtonsSplit = new RegExp(/(n|newton|newton)/);
// matches 42 k, 42.0 k or 42 kips or 42.0 kips
var kNRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(kn|kns|killonewton|killonewtons)(\s{0,})$/);
var kNSplit = new RegExp(/(kn|killonewton|killonewtons)/);

function parseLbs(s) {
  var tokens = s.split(lbsSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lbs: " + s);
    return 0;
  }
  return Number(tokens[0]);
}

function parseKips(s) {
  var tokens = s.split(kipsSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kips: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000;
}

function parseTons(s) {
  var tokens = s.split(tonsSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Tons: " + s);
    return 0;
  }
  return Number(tokens[0]) * 2000;
}

/* newtons to pounds */
function parseNewtons(s) {
  var tokens = s.split(newtonsSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Newtons: " + s);
    return 0;
  }
  return Number(tokens[0]) * 0.224808943;
}

/* kilonewtons to pounds */
function parseKN(s) {
  var tokens = s.split(kNSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing KN: " + s);
    return 0;
  }
  return Number(tokens[0]) * 224.809;
}

export function wsParseForce(s, defaultUnit) {
  if (s.match(integerRegEx) || s.match(decimalRegEx)) {
    if (defaultUnit) {
      if (defaultUnit === "kN") {
        return parseKN(s);
      }
      if (defaultUnit.match(kipsSplit)) {
        return parseKips(s);
      }
    }
    return Number(s);
  }
  if (s.match(lbsRegEx)) {
    return parseLbs(s);
  }
  if (s.match(kipsRegEx)) {
    return parseKips(s);
  }
  if (s.match(tonsRegEx)) {
    return parseTons(s);
  }
  if (s.match(newtonsRegEx)) {
    return parseNewtons(s);
  }
  if (s.match(kNRegEx)) {
    return parseKN(s);
  }
  return NaN;
}


function showForceSmartUnit(force) {
  // if it is smaller than 0.1 kips show it in pounds


}

function showPounds(num) {
  //assume num is in lbs (internal unit)
  return (Number(num)).toFixed(forcePrecisionDecimalPlaces);
}

function showNewtons(pounds) {
  return (Number(pounds) * 4.44822).toFixed(forcePrecisionDecimalPlaces);
}

export function showKips(num) {
  //assume num is in lbs (internal unit)
  return (Number(num) * 0.001).toFixed(forcePrecisionDecimalPlaces);
}

function showKN(pounds) {
  return (Number(pounds) * 0.00444822).toFixed(forcePrecisionDecimalPlaces);
}

function showSmallPointLoad(pounds) {
  if (gUnits === ENGLISH_UNITS) {
    return showPounds(pounds);
  } else {
    return showNewtons(pounds);
  }
}

function showBigPointLoad(pounds) {
  if (gUnits === ENGLISH_UNITS) {
    return showKips(pounds);
  } else {
    return showKN(pounds);
  }
}

function smallPointLoadUnit() {
  if (gUnits === ENGLISH_UNITS) {
    return "lbs";
  } else {
    return "N";
  }
}

function bigPointLoadUnit() {
  if (gUnits === ENGLISH_UNITS) {
    return "kips";
  } else {
    return "kN";
  }
}


/*
 * Moments
 */
var lbsInRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(-|.|(s\{0,}))(in|inch|inches)(\s{0,})$/);
var lbsInSplit = new RegExp(/(lb|lbs|pound|pounds)(-|.|(s\{0,}))(in|inch|inches)/);
var lbsFtRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(-|.|(s\{0,}))(ft|feet|foot)(\s{0,})$/);
var lbsFtSplit = new RegExp(/(lb|lbs|pound|pounds)(-|.|(s\{0,}))(ft|feet|foot)/);
var kipInRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(-|.|(s\{0,}))(in|inch|inches)(\s{0,})$/);
var kipInSplit = new RegExp(/(k|kip|kips)(-|.|(s\{0,}))(in|inch|inches)/);
var kipFtRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(-|.|(s\{0,}))(ft|feet|foot)(\s{0,})$/);
var kipFtSplit = new RegExp(/(k|kip|kips)(-|.|(s\{0,}))(ft|feet|foot)/);
var nMRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(n|newton|newtons)(-|.|(s\{0,}))(m|meter|meters)(\s{0,})$/);
var nMSplit = new RegExp(/(n|newton|newtons)(-|.|(s\{0,}))(m|meter|meters)/);
var kNMRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(kn|killonewton|killonewtons)(-|.|(s\{0,}))(m|meter|meters)(\s{0,})$/);
var kNMSplit = new RegExp(/(kn|killonewton|killonewtons)(-|.|(s\{0,}))(m|meter|meters)/);

function parseLbsIn(s) {
  var tokens = s.split(lbsInSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lb in: " + s);
    return 0;
  }
  return Number(tokens[0]);
}

function parseLbsFt(s) {
  var tokens = s.split(lbsFtSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lb Ft: " + s);
    return 0;
  }
  return Number(tokens[0]) * 12;
}

function parseKipIn(s) {
  var tokens = s.split(kipInSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kip In: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000;
}

function parseKipFt(s) {
  var tokens = s.split(kipFtSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kip Ft: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000 * 12;
}

function parseNM(s) {
  var tokens = s.split(nMSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing N M: " + s);
    return 0;
  }
  return Number(tokens[0]) * 39.370078 * 0.224808943;
}

function parsekNM(s) {
  var tokens = s.split(kNMSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing KN M: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000 * 39.370078 * 0.224808943;
}

export function wsParseMoment(s, defaultUnit) {
  if (s.match(integerRegEx) || s.match(decimalRegEx)) {
    if (defaultUnit) {
      if (defaultUnit.match(kipFtSplit)) {
        return Number(s) * 1000 * 12;
      }
      if (defaultUnit.match(kNMSplit), "i") {
        return Number(s) * 8850.75;
      }
    }
    return Number(s);
  }
  if (s.match(lbsInRegEx)) {
    return parseLbsIn(s);
  }
  if (s.match(lbsFtRegEx)) {
    return parseLbsFt(s);
  }
  if (s.match(kipInRegEx)) {
    return parseKipIn(s);
  }
  if (s.match(kipFtRegEx)) {
    return parseKipFt(s);
  }
  if (s.match(nMRegEx)) {
    return parseNM(s);
  }
  if (s.match(kNMRegEx)) {
    return parsekNM(s);
  }
  return NaN;
}

function showPoundIn(num) {
  //assume num is in lbs-in (internal unit)
  return Number(Number(num)).toFixed(momentPrecisionDecimalPlaces);
}

export function showKipFt(num) {
  //assume num is in lbs-in (internal unit)
  return Number(Number(num) / 1000 / 12).toFixed(momentPrecisionDecimalPlaces);
}

function showNM(poundInch) {
  //assume num is in lbs-in (internal unit)
  return Number(poundInch / 8850.7457673787 * 1000).toFixed(momentPrecisionDecimalPlaces);
}

function showKNM(poundInch) {
  //assume num is in lbs-in (internal unit)
  return Number(poundInch / 8850.7457673787).toFixed(momentPrecisionDecimalPlaces);
}

function showSmallMoment(poundInch) {
  if (gUnits === ENGLISH_UNITS) {
    return showPoundIn(poundInch);
  } else {
    return showNM(poundInch);
  }
}

function showBigMoment(poundInch) {
  if (gUnits === ENGLISH_UNITS) {
    return showKipFt(poundInch);
  } else {
    return showKNM(poundInch);
  }
}

function smallMomentUnit() {
  if (gUnits === ENGLISH_UNITS) {
    return "lb-in";
  } else {
    return "N-m";
  }
}

function bigMomentUnit() {
  if (gUnits === ENGLISH_UNITS) {
    return "kip-ft";
  } else {
    return "kN-m";
  }
}

/*
 * Forces per unit length
 */
var lbsPerInRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(in|inch|inches)(\s{0,})$/);
var lbsPerInSplit = new RegExp(/(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(in|inch|inches)/);
var lbsPerFtRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(ft|feet|foot)(\s{0,})$/);
var lbsPerFtSplit = new RegExp(/(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(ft|feet|foot)/);
var kipPerInRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(\s{0,1})\/(\s{0,1})(in|inch|inches)(\s{0,})$/);
var kipPerInSplit = new RegExp(/(k|kip|kips)(\s{0,1})\/(\s{0,1})(in|inch|inches)/);
var kipPerFtRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(\s{0,1})\/(\s{0,1})(ft|feet|foot)(\s{0,})$/);
export const kipPerFtSplit = new RegExp(/(k|kip|kips)(\s{0,1})\/(\s{0,1})(ft|feet|foot)/);
var nPerMRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(n|newton|newtons)(\s{0,1})\/(\s{0,1})(m|meter|meters)(\s{0,})$/);
var nPerMSplit = new RegExp(/(n|newton|newtons)(\s{0,1})\/(\s{0,1})(m|meter|meters)/);
var kNPerMRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(kn|killonewton|killonewtons)(\s{0,1})\/(\s{0,1})(m|meter|meters)(\s{0,})$/);
var kNPerMSplit = new RegExp(/(kn|killonewton|killonewtons)(\s{0,1})\/(\s{0,1})(m|meter|meters)/);

function parseLbsPerIn(s) {
  var tokens = s.split(lbsPerInSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lb/in: " + s);
    return 0;
  }
  return Number(tokens[0]);
}

function parseLbsPerFt(s) {
  var tokens = s.split(lbsPerFtSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lb/Ft: " + s);
    return 0;
  }
  return Number(tokens[0]) / 12;
}

function parseKipPerIn(s) {
  var tokens = s.split(kipPerInSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kip/In: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000;
}

function parseKipPerFt(s) {
  var tokens = s.split(kipPerFtSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kip/Ft: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000 / 12;
}

function parseNPerM(s) {
  var tokens = s.split(nPerMSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing N/M: " + s);
    return 0;
  }
  return Number(tokens[0]) * 39.370078 / 0.224808943;
}

function parsekNPerM(s) {
  var tokens = s.split(kNPerMSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing KN/M: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000 * 39.370078 / 0.224808943;
}

export function wsParseForcePerLength(s, defaultUnit) {
  if (s.match(integerRegEx) || s.match(decimalRegEx)) {
    if (defaultUnit) {
      if (defaultUnit.match(kipPerFtSplit)) {
        return Number(s) * 1000 / 12;
      }
      if (defaultUnit.match(kNPerMSplit), "i") {
        return Number(s) * 68.521766031484 / 12;
      }
    }
    return Number(s);
  }
  if (s.match(lbsPerInRegEx)) {
    return parseLbsPerIn(s);
  }
  if (s.match(lbsPerFtRegEx)) {
    return parseLbsPerFt(s);
  }
  if (s.match(kipPerInRegEx)) {
    return parseKipPerIn(s);
  }
  if (s.match(kipPerFtRegEx)) {
    return parseKipPerFt(s);
  }
  if (s.match(nPerMRegEx)) {
    return parseNPerM(s);
  }
  if (s.match(kNPerMRegEx)) {
    return parsekNPerM(s);
  }
  return NaN;
}

function showKipsPerFt(num) {
  //assume num is in lbs/in (internal unit)
  return (Number(num) / 1000 * 12).toFixed(forcePrecisionDecimalPlaces);
}

function showkNPerM(lbsPerInch) {
  return (Number(lbsPerInch) / 1000 * 39.370078 / 0.224808943).toFixed(forcePrecisionDecimalPlaces);
}

export function showBigLinearForce(inches) {
  if (gUnits === ENGLISH_UNITS) {
    return showKipsPerFt(inches);
  } else {
    return showkNPerM(inches);
  }
}


function bigLinearForceUnit() {
  if (gUnits === ENGLISH_UNITS) {
    return " k/ft";
  } else {
    return " kN/m";
  }
}


/*
 * Forces per unit area
 */
var lbsPerInInRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(in\^2|inch\^2)(\s{0,})$/);
var lbsPerInInSplit = new RegExp(/(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(in\^2|inch^2)/);
var kipPerInInRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(\s{0,1})\/(\s{0,1})(in\^2|inch^2)(\s{0,})$/);
var kipPerInInSplit = new RegExp(/(k|kip|kips)(\s{0,1})\/(\s{0,1})(in^2|inch\^2)/);
var ksiRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(ksi)$/);
var ksiSplit = new RegExp(/(ksi)/);

function parseLbsPerInIn(s) {
  var tokens = s.split(lbsPerInInSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lb/in^2: " + s);
    return 0;
  }
  return Number(tokens[0]);
}

function parseKipPerInIn(s) {
  var tokens = s.split(kipPerInInSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kip/In^2: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000;
}

function parseKsi(s) {
  var tokens = s.split(ksiSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing ksi: " + s);
    return 0;
  }
  return Number(tokens[0]) * 1000;
}

function wsParseForcePerArea(s, default_unit) {
  if (s.match(integerRegEx) || s.match(decimalRegEx)) {
    if (default_unit) {
      if (default_unit.match(kipPerInInSplit) || default_unit.match(ksiSplit)) {
        return Number(s) * 1000;
      }
    }
    return Number(s);
  }
  if (s.match(lbsPerInInRegEx)) {
    return parseLbsPerInIn(s);
  }
  if (s.match(kipPerInInRegEx)) {
    return parseKipPerInIn(s);
  }
  if (s.match(ksiRegEx)) {
    return parseKsi(s);
  }
  return NaN;
}

function showKsi(num) {
  //assume num is in lbs/in-in (internal unit)
  return (Number(num) / 1000).toFixed(2) + " ksi";
}
